import { Link } from 'react-router-dom';

export default function Breadcrumbs({ items }) {
  return (
    <nav style={{ fontSize: '12px', color: '#777', marginBottom: '12px' }}>
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i}>
            {i > 0 && <span style={{ margin: '0 6px' }}>&gt;</span>}
            {isLast ? (
              <span>{item.label}</span>
            ) : (
              <Link to={item.path} style={{ color: 'var(--color-accent)', textDecoration: 'none' }}>{item.label}</Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
